import React from 'react'
import { componentKey, setIsTinMatchSelectAll, setTinMatchConfirmationModalOpen, setTinMatchFinalReportModalOpen, setTinMatchForAllRecipientsModalOpen, setTinMatchProceedRequest } from './TinMatchSlice';
import { useDispatch, useSelector } from 'react-redux';
import TinMatchPopup from "./tinmatchpopup/TinMatchPopup"
import { BUTTON_TYPE } from '../../../../components/button/constants';
import { VEC_ICON_NAME } from '../../../../components/icons/constants';
import styles from '../RecipientList.styles'
import { getRequestedCount, getTinMatchFee } from './TinMatchSaga';
import { componentKey as recipentSectionSliceComponentKey } from "../../RecipientsSectionSlice"
import { componentKey as recipientsListcomponentKey, setShouldReloadPaginatedRecipientList } from "../RecipientListSlice"
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../../components/paymentdrawer/constants';
import RecipientDataService from '../../../../../services/RecipientDataService';
import PaymentDrawer from '../../../components/paymentdrawer/PaymentDrawer';
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks';
import Loadable from '../../../../components/loadable/Loadable';
import { TIN_MATCH_MODALS_LOADING_STATE } from './constants';
import { TOASTER_VARIANT } from '../../../../components/toast/constants';

const TinMatchModals = () => {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch();

    const { loadingState, tinMatchConfirmationModalOpen, tinMatchForAllRecipientsModalOpen, tinMatchProceedRequest, tinMatchFinalReportModalOpen, requestedCount, tinMatchFees, isTinMatchSelectAll } = useSelector(state => state[componentKey]);
    const { selectedPayer } = useSelector(state => state[recipentSectionSliceComponentKey])
    const { selectedRecipients, highlightedRecipient } = useSelector(state => state[recipientsListcomponentKey])
    
    return (
        <Loadable
            currentState={loadingState?.state}
            loadingStates={[TIN_MATCH_MODALS_LOADING_STATE.GET_REQUESTED_COUNT_LOADING, TIN_MATCH_MODALS_LOADING_STATE.GET_TIN_MATCH_FEE_LOADING]}
            isNewLoadable={true}
            preserveChildMount={true}
            messageMap={{}}
        >

            {/* TIN Match confirmation modal step 1 */}

            <TinMatchPopup title='Are you sure?'
                bodyText='Do you want to TIN MATCH all recipients under selected payer or TIN MATCH only selected recipients ?'
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={tinMatchConfirmationModalOpen}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        let data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: selectedRecipients.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient.RecipentDetailId], IsAllSelect: true }
                        dispatch(setIsTinMatchSelectAll(true))
                        dispatch(getRequestedCount(data))
                    },
                    confirmationButtonText: "TIN Match All Recipients",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        let data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: selectedRecipients.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient.RecipentDetailId], IsAllSelect: false }
                        dispatch(setIsTinMatchSelectAll(false))
                        dispatch(getRequestedCount(data))
                    },
                    onCloseCb: () => {
                        dispatch(setTinMatchConfirmationModalOpen(false))
                    },
                    cancelButtonText: "TIN Match Selected Recipients",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                isClose={false}
                style={styles.tinMatchPopup}
            />

            {/* TIN Match all recipients confirmation modal step 2 */}

            <TinMatchPopup title='Are you sure?'
                bodyText={`A TIN match request has been submitted for ${requestedCount.TinMatchingRequests || 0} recipients and ${requestedCount.AcceptedRequests || 0} Accepted TIN match recipients.`}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={tinMatchForAllRecipientsModalOpen}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        if(requestedCount.TinMatchingRequests !== 0 && requestedCount.TinMatchingRequests == requestedCount.AcceptedRequests){
                            dispatch(addNotifications({ heading: "Error", message: "TIN match request count should not be equal to the accepted request count", variant: TOASTER_VARIANT.WARNING }));
                            dispatch(setTinMatchForAllRecipientsModalOpen(false))
                        } else if (requestedCount.TinMatchingRequests !== 0) {
                            dispatch(setTinMatchForAllRecipientsModalOpen(false))
                            dispatch(setTinMatchConfirmationModalOpen(false))
                            dispatch(setTinMatchProceedRequest(true))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "TIN match count should be greater than 0." }));
                        }
                    },
                    confirmationButtonText: "Proceed",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setTinMatchForAllRecipientsModalOpen(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
            />

            {/* TIN Match click confirmation modal step 3 */}

            <TinMatchPopup title='Are you sure?'
                bodyText='Click on proceed to request TIN match'
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={tinMatchProceedRequest}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(setTinMatchProceedRequest(false))
                        let requestData = { payerId: selectedPayer.PayerDetailId, RecipientIds: selectedRecipients.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient.RecipentDetailId], selectAll: isTinMatchSelectAll }
                        dispatch(getTinMatchFee(requestData))
                    },
                    confirmationButtonText: "Proceed",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setTinMatchProceedRequest(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
            />

            {tinMatchFinalReportModalOpen &&
                <PaymentDrawer
                    isOpen={tinMatchFinalReportModalOpen}
                    onCloseCb={() => dispatch(setTinMatchFinalReportModalOpen(false))}
                    fees={{
                        OnlySeparateStatefiling: "false",
                        TotalFilingFee: tinMatchFees,
                        FilingFee: "0",
                        USPSFee: "0",
                        TINMatchFee: tinMatchFees,
                        StateFee: "0",
                        TINCount: requestedCount?.TinMatchingRequests,
                        StateFilingCount: "0",
                        USPSCount: "0",
                        FormCount: "0"
                    }}
                    calculatePrepaySalesTax={true}
                    paymentServiceFunctionCb={RecipientDataService.tinMatchRequest}
                    placeOfOriginforpayment={(selectedRecipients.length > 1 || isTinMatchSelectAll) ? PLACE_OF_ORIGIN_FOR_PAYMENT.BULK_TIN_PAYMENT : PLACE_OF_ORIGIN_FOR_PAYMENT.SINGLE_TIN_PAYMENT}
                    onPaymentSuccessCb={() => { dispatch(setShouldReloadPaginatedRecipientList(true))}}
                    paymentServiceFunctionExtraParams={{
                        RecipientIds: selectedRecipients?.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient?.RecipentDetailId],
                        selectAll: isTinMatchSelectAll,
                        isAccountant: "true",
                        PayerId: selectedPayer?.PayerDetailId,
                        payerId: selectedPayer?.PayerDetailId,
                    }}
                />
            }
        </Loadable>
    )
}

export default TinMatchModals
